import { render, staticRenderFns } from "./CreateBatch.vue?vue&type=template&id=ef84097e&"
import script from "./CreateBatch.vue?vue&type=script&lang=js&"
export * from "./CreateBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports